<script>

import { Line } from 'vue-chartjs'
// import core from '../../plugins/core';

var yellowColor = "#fbc02d"
var blueColor = 'rgba(54, 162, 235, 1)'
var purpleColor = '#A534D9'
var orangeColor = '#df6e37'
var tealColor = '#37df90'
var whiteColor = '#FFF'
var greyColor = '#CCC'

export default {
    extends: Line,
    props: [ 'history' ],
    data() {
      return {
        chartData: {
          labels: [],
          datasets: [
            {
                label: 'mmInitialeUnity ù',
                lineTension: 0,
                //backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: blueColor,
                borderWidth: 2,
                pointRadius: 2,
                pointBackgroundColor: blueColor,
                pointBorderColor: blueColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: blueColor,
                pointHoverBorderColor: blueColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes1'
            },
            {
                label: 'mmInitialePRT',
                lineTension: 0,
                //backgroundColor: 'rgba(54, 162, 235, 0.2)',
                borderColor: orangeColor,
                borderWidth: 2,
                pointRadius: 2,
                pointBackgroundColor: orangeColor,
                pointBorderColor: orangeColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: orangeColor,
                pointHoverBorderColor: orangeColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
            {
                label: 'mmReelle PRT',
                lineTension: 0,
                backgroundColor: "rgba(251, 192, 45, 0.5)",
                borderColor: yellowColor,
                borderWidth: 2,
                pointRadius: 2,
                pointBackgroundColor: yellowColor,
                pointBorderColor: yellowColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: yellowColor,
                pointHoverBorderColor: yellowColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
            {
                label: 'mmDepot PRT',
                lineTension: 0,
                backgroundColor: "#9c27b03b",
                borderColor: purpleColor,
                borderWidth: 4,
                pointRadius: 0,
                pointBackgroundColor: purpleColor,
                pointBorderColor: purpleColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: purpleColor,
                pointHoverBorderColor: purpleColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
            {
                label: 'mmTotalReel PRT',
                lineTension: 0,
                // backgroundColor: "rgba(251, 192, 45, 0.24)",
                borderColor: tealColor,
                borderWidth: 4,
                pointRadius: 0,
                pointBackgroundColor: tealColor,
                pointBorderColor: tealColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: tealColor,
                pointHoverBorderColor: tealColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes2'
            },
            {
                label: 'percentDepotVSReel %',
                lineTension: 0,
                // backgroundColor: "rgba(251, 192, 45, 0.24)",
                borderColor: whiteColor,
                borderWidth: 2,
                pointRadius: 0,
                pointBackgroundColor: whiteColor,
                pointBorderColor: whiteColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: whiteColor,
                pointHoverBorderColor: whiteColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes3'
            },
            {
                label: 'percentDepotVSInitial %',
                lineTension: 0,
                // backgroundColor: "rgba(251, 192, 45, 0.24)",
                borderColor: greyColor,
                borderWidth: 2,
                pointRadius: 0,
                pointBackgroundColor: greyColor,
                pointBorderColor: greyColor,
                pointHoverRadius: 3,
                pointHoverBackgroundColor: greyColor,
                pointHoverBorderColor: greyColor,
                pointHitRadius: 10,
                pointBorderWidth: 1,
                data: [],
                yAxisID: 'yAxes3'
            },
          ]
        },
        chartOptions: {
            maintainAspectRatio: false,
            title: { display: false },
            scales: {
                yAxes: [
                {
                    id: 'yAxes1',
                    type: 'linear',
                    position: 'left',
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return value + " ù";
                        }
                    }
                },
                {
                    id: 'yAxes2',
                    type: 'linear',
                    position: 'right',
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return value + " PRT";
                        }
                    }
                },
                {
                    id: 'yAxes3',
                    type: 'linear',
                    position: 'right',
                    ticks: {
                        beginAtZero: true,
                        maxTicksLimit: 8,
                        callback: function(value) {
                            return value + " %";
                        }
                    }
                }
                ]
            },
            legend: {
                display: true
            }
        },
      }
    },
    mounted: function(){  
        this.calcWalletMainValues()
        this.renderChart(this.chartData, this.chartOptions)

        this.$root.$on('updateChartTutoHistory', () => { 
            //console.log("updateChartTutoHistory")
            this.calcWalletMainValues()
            // this.renderChart(this.chartData, this.chartOptions)
            this.$data._chart.update() 
        })
    },
    beforeDestroy: function() {
        this.$root.$off('updateChartTutoHistory',)
    },
    methods: {
        calcWalletMainValues: function(){
            //console.log("history", this.history)
            let lbls = []
            let attrs = ["mmInitialeUnity", "mmInitialePRT", "mmReelle", "mmDepot", "mmTotalReel", "percentDepotVSReel", "percentDepotVSInitial"]

            attrs.forEach((value, v) => { this.chartData.datasets[v].data = [] })
            //console.log("datasets0", this.chartData.datasets[0].data)
            //console.log("datasets1", this.chartData.datasets[1].data)
            this.history.forEach((dayValue, d) => {
                attrs.forEach((attr, v) => {
                    if(dayValue[attr] != null){
                        this.chartData.datasets[v].data.push(parseFloat(dayValue[attr]))
                    }
                })
                lbls.push("J+" + d)
            })
            this.chartData.labels = lbls
            //console.log("lbls", lbls)
        },
    }
  }
</script>